import React from 'react';

const LegalSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
    <div className="mb-8">
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white mb-3">{title}</h2>
        <div className="space-y-4 text-slate-600 dark:text-zinc-300">{children}</div>
    </div>
);

const TermsOfServicePage: React.FC = () => {
    return (
        <div className="py-20 animate-fadeIn">
            <div className="container mx-auto px-4 max-w-4xl">
                <div className="text-center mb-12">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 dark:text-white">Terms of Service</h1>
                    <p className="mt-4 text-lg text-slate-500 dark:text-zinc-400">
                        Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </p>
                </div>

                <div className="prose dark:prose-invert prose-lg max-w-none">
                    <LegalSection title="1. Agreement to Terms">
                        <p>
                            By using our Services, you agree to be bound by these Terms of Service ("Terms"). If you do not agree to be bound by these Terms, do not use the Services.
                        </p>
                    </LegalSection>

                    <LegalSection title="2. Use of Our Services">
                        <p>
                            You must use our Services in compliance with all applicable laws, rules, and regulations. You are responsible for your conduct and any data, text, files, information, usernames, images, graphics, photos, profiles, audio and video clips, sounds, musical works, works of authorship, applications, links and other content or materials (collectively, "Content") that you submit, post or display on or via the Service.
                        </p>
                        <p>
                            You agree that you will not:
                        </p>
                         <ul>
                            <li>Use the Services for any illegal or unauthorized purpose.</li>
                            <li>Interfere with or disrupt the Services or servers or networks connected to the Services.</li>
                            <li>Attempt to gain unauthorized access to any portion of the Services or any other systems or networks.</li>
                        </ul>
                    </LegalSection>

                    <LegalSection title="3. Accounts">
                        <p>
                            When you create an account with us, you must provide us information that is accurate, complete, and current at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our Service.
                        </p>
                    </LegalSection>

                    <LegalSection title="4. Intellectual Property">
                        <p>
                            The Service and its original content, features and functionality are and will remain the exclusive property of Wampia and its licensors. The Service is protected by copyright, trademark, and other laws of both Nigeria and foreign countries.
                        </p>
                    </LegalSection>

                    <LegalSection title="5. Termination">
                        <p>
                            We may terminate or suspend your account immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease.
                        </p>
                    </LegalSection>

                    <LegalSection title="6. Limitation of Liability">
                        <p>
                           In no event shall Wampia, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Service.
                        </p>
                    </LegalSection>

                    <LegalSection title="7. Governing Law">
                        <p>
                            These Terms shall be governed and construed in accordance with the laws of the Federal Republic of Nigeria, without regard to its conflict of law provisions.
                        </p>
                    </LegalSection>

                     <LegalSection title="8. Changes to Terms">
                        <p>
                           We reserve the right, at our sole discretion, to modify or replace these Terms at any time. We will provide at least 30 days' notice prior to any new terms taking effect. By continuing to access or use our Service after those revisions become effective, you agree to be bound by the revised terms.
                        </p>
                    </LegalSection>

                    <LegalSection title="9. Contact Us">
                        <p>
                           If you have any questions about these Terms, please contact us at: <a href="mailto:legal@wampia.ai" className="text-[#05F564] hover:underline">legal@wampia.ai</a>
                        </p>
                    </LegalSection>
                </div>
            </div>
        </div>
    );
};

export default TermsOfServicePage;
